import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import SampleImage from "../assets/newimage/first27.jpg"; 
import SampleImage2 from "../assets/newimage/first31.jpg"; 
import SampleImage3 from "../assets/newimage/first8.jpg"; 

function AboutPage() {
  return (
    <div className="bg-white text-[#1A3C34] font-sans">
      <Navbar />

      {/* Hero Section */}
      <section className="max-w-6xl mx-auto px-6 py-24 grid md:grid-cols-2 gap-16 items-center">
        {/* Image */}
        <div className="h-full w-full overflow-hidden shadow-xl">
          <img
            src={SampleImage}
            alt="Elizabeth Jacobs Portrait"
            className="h-full w-full object-cover object-center"
          />
        </div>

        {/* Text */}
        <div>
          <h2 className="text-4xl md:text-5xl font-bold leading-tight mb-6">
            Meet Elizabeth Jacobs: Your Partner in <span className="italic text-[#F9C93F]">Holistic Wellness</span>
          </h2>
          <p className="text-lg text-gray-700 leading-relaxed mb-4">
            I’m Elizabeth — wellness coach, advocate for intuitive living, and firm believer that lasting health is a joyful journey, not a chore.
          </p>
          <p className="text-lg text-gray-700 leading-relaxed">
            Through my own healing experiences, I’ve learned that the most powerful transformations happen when we nurture not just the body, but the mind and spirit too. That’s why I combine evidence-based strategies with heart-centered coaching to guide you toward vibrant, sustainable well-being.
          </p>
        </div>
      </section>

      {/* Coaching Philosophy Section */}
      <section className="bg-[#f1f4ec] py-20 px-6">
        <div className="max-w-6xl mx-auto text-center">
          <h2 className="text-4xl md:text-5xl font-bold leading-tight mb-8">
            My Philosophy: Empowering <span className="italic text-[#F9C93F]">Sustainable Change</span>
          </h2>
          <p className="text-lg text-gray-700 leading-relaxed max-w-3xl mx-auto">
            Every woman’s wellness journey is unique — and so is the coaching experience I create. Together, we’ll co-create a plan rooted in science, aligned with your lifestyle, and focused on small, sustainable shifts that build momentum toward a life you love. 
          </p>
        </div>
      </section>

      {/* Nouriv Advantage Section */}
      <section className="bg-white py-20 px-6">
        <div className="max-w-6xl mx-auto grid md:grid-cols-2 gap-16 items-center">
          {/* Text */}
          <div>
            <h2 className="text-4xl md:text-5xl font-bold leading-tight mb-6">
              Your Journey, Elevated: The <span className="italic text-[#F9C93F]">Nouriv Advantage</span>
            </h2>
            <p className="text-lg text-gray-700 leading-relaxed mb-4">
              My secret to delivering seamless support? Nouriv — a smart, intuitive dashboard that gives you everything you need in one beautiful, personalized space.
            </p>
            <p className="text-lg text-gray-700 leading-relaxed">
              Whether you’re tracking progress, joining sessions, accessing replays, or exploring my curated library, Nouriv makes it easy to stay engaged and empowered. It’s more than a tool — it’s part of the transformation.
            </p>
          </div>

          {/* Image */}
          <div className="h-full w-full overflow-hidden shadow-xl">
            <img
              src={SampleImage2}
              alt="Nouriv Dashboard Screenshot"
              className="h-full w-full object-cover object-center"
            />
          </div>
        </div>
      </section>

      {/* Community Section */}
      <section className="bg-[#f1f4ec] py-20 px-6">
        <div className="max-w-6xl mx-auto grid md:grid-cols-2 gap-16 items-center">
          {/* Image */}
          <div className="h-full w-full overflow-hidden shadow-xl">
            <img
              src={SampleImage3}
              alt="Community engagement"
              className="h-full w-full object-cover object-center"
            />
          </div>

          {/* Newsletter Signup */}
          <div className="bg-white p-10 shadow-xl text-center">
            <h2 className="text-3xl font-bold mb-4">
              Join Our <span className="italic text-[#F9C93F]">Vibrant Wellness Community</span>
            </h2>
            <p className="text-md text-gray-700 mb-6">
              Receive practical wellness tips, exclusive resources, and soulful inspiration straight to your inbox. Be the first to know about new programs, retreats, and coaching spots.
            </p>
            <form className="flex flex-col items-center gap-4">
              <input
                type="email"
                placeholder="Your Email Address"
                className="w-full max-w-md px-5 py-3 border border-gray-300  focus:ring-2 focus:ring-[#4BAF47] focus:border-transparent text-gray-800"
              />
              <button className="bg-[#1A3C34] text-white px-8 py-3 rounded-lg font-semibold text-lg hover:bg-[#2e5d50] transition-colors duration-300 shadow-md">
                Subscribe Now
              </button>
            </form>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}

export default AboutPage;
